import "./Footer.css";
function Footer() {
	return <footer className="footer">© 2025 Adan Gomez. All Rights Reserved</footer>;
}

export default Footer;
